/**
 * @author HungNS
 */
import * as TYPE from './type'
import IConstants from '@/common/constants/IConstants'
import ServiceUtils from '@/common/utils/ServiceUtils'
import i18n from '@/lang/i18n'
import {find, floor, isEmpty, isNil} from 'lodash'
import {isNumber} from '@/common/helpers/store';
import * as FORCE_NEWS_TYPE from '../force-news/type'

const listFinalAssets = IConstants.listFinalAssets;

/* eslint-disable no-unused-vars */

const moduleProfile = {
    namespaced: true,
    state: () => ({
        fetchDataSuccess: false,
        customerInfoView: null,
        isCorporation: false,
        input: {},
        masterInput: {},
        hasAdditionEmail: false,
        enableNotificationLogin: false,
        SUPPORT_DOCUMENT_URL: '',
        SUPPORT_DOMINATOR_URL: '',
        SUPPORT_FORM_URL: '',
        NEW_UPLOAD_DOCUMENT_URL: '',
        isEaAccount: 0,
        socialAccount: null,
        hasSocialAccount: false,
        ntdAccount: null,
        hasNtdAccount: false,
        fxAccount: null,
        boAccount: null,
        hasBoAccount: false,
        cryptAccount: null,
        hasCryptAccount: false,
        loginNotifyFlgView: "0",
        activeBlock: '',
        passkeyStatus: null,
        maskingVerifiedPerSession: false,
        maskingVerifiedPerRequest: false,
        //add amsWhitelabelConfigInfo from force-news state
        amsWhitelabelConfigInfo: [],
        disabledLoginNotifyMainMail: false,
        disabledLoginNotifyAdditionalMail: false
    }),
    mutations: {
        [TYPE.SET_ACTIVE_BLOCK](state, payload) {
            state.activeBlock = payload;
        },
        [TYPE.SET_AMS_CUSTOMER_INFO](state, payload) {
            init(state, payload);
            state.masterInput =  JSON.stringify(state.input);
            state.fetchDataSuccess = true;
        },

        [TYPE.VALIDATE_SELF_ASSET](state, payload) {
            state.input = {...state.input, ...payload};
            invalidSelfAssets(state)
        },
        [TYPE.VALIDATE_BO_MAX_LOSS_AMOUNT](state, payload) {
            state.input = {...state.input, ...payload};
            validateBoMaxLossAmount(state);
        },
        changeLoginNotifyMainMail(state, payload) {
            state.input = {...state.input, payload};
            changeNotificationLogin(state, IConstants.LOGIN_NOTIFY.MAIN_MAIL)
        },
        changeLoginNotifyAdditionalMail(state, payload) {
            state.input = {...state.input, payload};
            changeNotificationLogin(state, IConstants.LOGIN_NOTIFY.ADDITIONAL_MAIL)
        },
        [TYPE.SET_ALERT_PASS2_FAIL](state, payload) {
            state.input = {...state.input, payload};
            changeAuthenticateAlert(state)
        },
        [TYPE.SET_ADDITIONAL_MAIL](state, payload) {
            state.hasAdditionEmail = payload.hasAdditionEmail;
        },
        [TYPE.UPDATE_CUSTOMER_INFO](state, payload) {
            const subFieldPrefix = "amsCustomerDetail";
            let inputKey = '';
            for (const key in payload.amsCustomerInfoView) {
                inputKey = `${subFieldPrefix}.${key}`;
                state.input[inputKey] = payload.amsCustomerInfoView[key];
            }
            state.masterInput = JSON.stringify(state.input);
        },
        assignProfileState(state, payload) {
            Object.assign(state, payload);
        }
    },
    actions: {
        async [TYPE.GET_AMS_CUSTOMER_INFO]({commit, rootState}, payload) {
            const data = payload;
            if (data) {
                commit(TYPE.SET_AMS_CUSTOMER_INFO, {rootState, data})
            }
        },
        async [TYPE.INIT_PROFILE_INFO]({dispatch, rootState}, payload) {
            if (rootState.forceNews.systemCache === null) {
                await dispatch('forceNews/' + FORCE_NEWS_TYPE.GET_SYSTEM_CACHE, null, {root: true})
            }
            await dispatch(TYPE.GET_AMS_CUSTOMER_INFO, payload)
        },
        [TYPE.GET_VALIDATE_SELF_ASSET]({commit}, payload) {
            commit(TYPE.VALIDATE_SELF_ASSET, payload);
        },
        [TYPE.GET_VALIDATE_BO_MAX_LOSS_AMOUNT]({commit}, payload) {
            commit(TYPE.VALIDATE_BO_MAX_LOSS_AMOUNT, payload);
        },
        changeLoginNotifyMainMail({commit}, payload) {
            commit('changeLoginNotifyMainMail', payload);
        },
        changeLoginNotifyAdditionalMail({commit}, payload) {
            commit('changeLoginNotifyAdditionalMail', payload);
        },
        [TYPE.GET_ALERT_PASS2_FAIL]({commit}, payload) {
            commit(TYPE.SET_ALERT_PASS2_FAIL, payload);
        },
        reverseInput({state}, payload) {
            const masterInput = JSON.parse(state.masterInput);
            state.input = {...masterInput};
        },
        setActiveBlock({commit}, payload) {
            commit(TYPE.SET_ACTIVE_BLOCK, payload);
        },
        updateCustomerInfo({commit}, payload) {
            commit(TYPE.UPDATE_CUSTOMER_INFO, payload)
        },
        [TYPE.SET_ADDITIONAL_MAIL]({commit}, payload) {
            commit(TYPE.SET_ADDITIONAL_MAIL, payload);
        },
    },
    getters: {
        activeBlock({activeBlock}) {
            return activeBlock;
        },
    }
};

const init = (state, payload) => {
    const {data, rootState} = payload;
    state.customerInfoView = data.amsCustomerInfoView;
    const serviceTypeInfoViews = state.customerInfoView?.serviceTypeInfoViews;
    if (data.supportDocumentUrl !== null) state.SUPPORT_DOCUMENT_URL = data.supportDocumentUrl;
    if (data.supportDominatorUrl !== null) state.SUPPORT_DOMINATOR_URL = data.supportDominatorUrl;
    if (data.supportFormUrl !== null) state.SUPPORT_FORM_URL = data.supportFormUrl;
    if (data.newDocumentUploadUrl !== null) state.NEW_UPLOAD_DOCUMENT_URL = data.newDocumentUploadUrl;
    state.isEaAccount = state.customerInfoView?.isEaAccount;
    state.maskingVerifiedPerSession = data.authenticateModel?.maskingVerifiedPerSession;
    state.maskingVerifiedPerRequest = data.authenticateModel?.maskingVerifiedPerRequest;
    for (let index in serviceTypeInfoViews) {
        if (serviceTypeInfoViews[index].serviceType === IConstants.SERVICE_TYPE.SOCIAL) {
            state.socialAccount = serviceTypeInfoViews[index];
            state.hasSocialAccount = true;
        }
        if (serviceTypeInfoViews[index].serviceType === IConstants.SERVICE_TYPE.NTD_FX) {
            state.ntdAccount = serviceTypeInfoViews[index];
            state.hasNtdAccount = true;
        }
        if (serviceTypeInfoViews[index].serviceType === IConstants.SERVICE_TYPE.BO) {
            state.boAccount = serviceTypeInfoViews[index];
            state.hasBoAccount = true;
        }
        if (serviceTypeInfoViews[index].serviceType === IConstants.SERVICE_TYPE.CRYPTO_FX) {
            state.cryptAccount = serviceTypeInfoViews[index];
            state.hasCryptAccount = true;
        }
    }
    if (state.customerInfoView?.corporationType === IConstants.CUSTOMER_TYPE.INDIVIDUAL) {
        state.isCorporation = false;
        state.genderView = find(IConstants.listGender, item => (item.key == state.customerInfoView?.gender)).value;
    } else {
        state.isCorporation = true;
    }

    if (rootState.forceNews.systemCache) {
        state.amsWhitelabelConfigInfo = JSON.parse(JSON.stringify(rootState.forceNews.systemCache.amsWhitelabelConfigInfo));
    }
    initInput(state);
};
const initInput = (state) => {
    state.enableNotificationLogin = false;
    const boLossMaxAmount = state.customerInfoView?.boLossMaxAmount;
    if (boLossMaxAmount && boLossMaxAmount !== "") {
        const amt = boLossMaxAmount.replace(/[^0-9.]/g, '');
        state.customerInfoView.boLossMaxAmount = floor(amt) + '';
    }

    let input = {};

    for (let fieldAmsCustomer in state.customerInfoView) {
        if (fieldAmsCustomer === "investmentView" || fieldAmsCustomer === "boInvestmentPurposeView") {
            input["amsCustomerDetail." + fieldAmsCustomer] = state.customerInfoView[fieldAmsCustomer];
        } else if (fieldAmsCustomer === "picPerfecture" || fieldAmsCustomer === "prefecture" || fieldAmsCustomer.includes("beneficOwnerPrefecture")) {
            input["amsCustomerDetail." + fieldAmsCustomer] = ServiceUtils.convertHalfwidthToFullwidthReturn(state.customerInfoView[fieldAmsCustomer]);
        } else if (fieldAmsCustomer === "additionalEmail") {
            input["amsCustomerDetail." + fieldAmsCustomer] = state.customerInfoView[fieldAmsCustomer];
            if (state.customerInfoView[fieldAmsCustomer]) {
                state.hasAdditionEmail = true;
            }
        } else if (fieldAmsCustomer === 'passkeyStatus') state.passkeyStatus = state.customerInfoView['passkeyStatus'];
        else if (fieldAmsCustomer === 'loginNotifyFlg') initLoginNotification(state, input);
        else if (fieldAmsCustomer === 'alertAuthFlg') initAuthenticateAlert(state, input);
        else input["amsCustomerDetail." + fieldAmsCustomer] = state.customerInfoView[fieldAmsCustomer];
    }
    input['amsCustomerDetail.verifyCode'] = "";
    input['amsCustomerDetail.verifyCodePass2'] = "";

    //Update password add
    input['amsCustomerDetail.newPassword'] = "";
    input['amsCustomerDetail.currentPassword'] = "";
    input['amsCustomerDetail.reTypePassword'] = "";

    state.input = {...input};
    validateSelfAssetAndBoMaxLoss(state)

};

const initLoginNotification = (state, input) => {
    const loginNotifyFlg = state.customerInfoView['loginNotifyFlg'].toString();
    if (loginNotifyFlg !== IConstants.LOGIN_NOTIFY.INACTIVE) {
        state.enableNotificationLogin = true;
        input["amsCustomerDetail.loginNotifyFlg"] = state.customerInfoView['loginNotifyFlg'];
        if (loginNotifyFlg === IConstants.LOGIN_NOTIFY.ACTIVE) {
            input["amsCustomerDetail.loginNotifyMainMailFlg"] = IConstants.FLAG.ACTIVE;
            input["amsCustomerDetail.loginNotifyAdditionalMailFlg"] = IConstants.FLAG.ACTIVE;
        } else if (loginNotifyFlg === IConstants.LOGIN_NOTIFY.MAIN_MAIL) {
            input["amsCustomerDetail.loginNotifyMainMailFlg"] = IConstants.FLAG.ACTIVE;
        } else if (loginNotifyFlg === IConstants.LOGIN_NOTIFY.ADDITIONAL_MAIL) {
            input["amsCustomerDetail.loginNotifyAdditionalMailFlg"] = IConstants.FLAG.ACTIVE;
        }
    } else {
        input['amsCustomerDetail.loginNotifyMainMailFlg'] = IConstants.FLAG.INACTIVE;
    }
    if (state.customerInfoView['additionalEmail'] === '') {
        input['amsCustomerDetail.loginNotifyAdditionalMailFlg'] = IConstants.FLAG.INACTIVE;
    }
    state.loginNotifyFlgView = loginNotifyFlg;

    customDisableLoginNotificationOptions(state)
};

const customDisableLoginNotificationOptions = (state) => {
    if (!state.customerInfoView['additionalEmail']) {
        state.disabledLoginNotifyAdditionalMail = true;
        if (isOneMailMustEnable(state)) state.disabledLoginNotifyMainMail = true;
    }
};

const changeNotificationLogin = (state, mailType) => {
    changeNotificationLoginForUnSetPasskeyYet(state, mailType)

    state.enableNotificationLogin = false;
    const loginNotifyMainMailFlg = getLoginNotifyOrDefault(state.input["amsCustomerDetail.loginNotifyMainMailFlg"]);
    const loginNotifyAdditionalMailFlg = getLoginNotifyOrDefault(state.input["amsCustomerDetail.loginNotifyAdditionalMailFlg"]) ;
    let loginNotifyFlag = IConstants.LOGIN_NOTIFY.INACTIVE;
    if (loginNotifyMainMailFlg === IConstants.FLAG.ACTIVE && loginNotifyAdditionalMailFlg === IConstants.FLAG.ACTIVE)
        loginNotifyFlag = IConstants.LOGIN_NOTIFY.ACTIVE;
    else if (loginNotifyMainMailFlg === IConstants.FLAG.ACTIVE && loginNotifyAdditionalMailFlg === IConstants.FLAG.INACTIVE)
        loginNotifyFlag = IConstants.LOGIN_NOTIFY.MAIN_MAIL;
    else if (loginNotifyAdditionalMailFlg === IConstants.FLAG.ACTIVE && loginNotifyMainMailFlg === IConstants.FLAG.INACTIVE)
        loginNotifyFlag = IConstants.LOGIN_NOTIFY.ADDITIONAL_MAIL;
    if (loginNotifyFlag !== IConstants.LOGIN_NOTIFY.INACTIVE) state.enableNotificationLogin = true;
    state.input["amsCustomerDetail.loginNotifyFlg"] = loginNotifyFlag;
};

const changeNotificationLoginForUnSetPasskeyYet = (state, mailType) => {
    if (isOneMailMustEnable(state)) {
        if (IConstants.LOGIN_NOTIFY.MAIN_MAIL === mailType) {
            if (getLoginNotifyOrDefault(state.input["amsCustomerDetail.loginNotifyMainMailFlg"]) === IConstants.FLAG.INACTIVE)
                state.input["amsCustomerDetail.loginNotifyAdditionalMailFlg"] = IConstants.FLAG.ACTIVE;
        } else {
            if (getLoginNotifyOrDefault(state.input["amsCustomerDetail.loginNotifyAdditionalMailFlg"]) === IConstants.FLAG.INACTIVE)
                state.input["amsCustomerDetail.loginNotifyMainMailFlg"] = IConstants.FLAG.ACTIVE;
        }
    }
};

const getLoginNotifyOrDefault = (value) => {
    if (!value) return '0';
    return String(value)
}

const isOneMailMustEnable = (state) => {
    return ServiceUtils.isServiceOpenCompletedV2(state.socialAccount?.customerServiceStatus)
};

const initAuthenticateAlert = (state, input) => {
    let alertAuthFlg = String(state.customerInfoView['alertAuthFlg']);
    if (alertAuthFlg === IConstants.LOGIN_NOTIFY.INACTIVE)
        input['amsCustomerDetail.authenticateAlertMainMail'] = IConstants.FLAG.INACTIVE;
    else {
        input["amsCustomerDetail.alertAuthFlg"] = state.customerInfoView['alertAuthFlg'];
        if (alertAuthFlg === IConstants.LOGIN_NOTIFY.ACTIVE) {
            input["amsCustomerDetail.authenticateAlertMainMail"] = IConstants.FLAG.ACTIVE;
            input["amsCustomerDetail.authenticateAlertAdditionalMail"] = IConstants.FLAG.ACTIVE;
        } else if (alertAuthFlg === IConstants.LOGIN_NOTIFY.MAIN_MAIL)
            input["amsCustomerDetail.authenticateAlertMainMail"] = IConstants.FLAG.ACTIVE;
        else if (alertAuthFlg === IConstants.LOGIN_NOTIFY.ADDITIONAL_MAIL)
            input["amsCustomerDetail.authenticateAlertAdditionalMail"] = IConstants.FLAG.ACTIVE;
    }
    if (state.customerInfoView['additionalEmail'] === '')
        input['amsCustomerDetail.authenticateAlertAdditionalMail'] = IConstants.FLAG.INACTIVE;
};

const changeAuthenticateAlert = (state) => {
    let authenticateAlertMainMail = state.input["amsCustomerDetail.authenticateAlertMainMail"] === undefined
        ? "0"
        : String(state.input["amsCustomerDetail.authenticateAlertMainMail"]);
    let authenticateAlertAdditionalMail = state.input["amsCustomerDetail.authenticateAlertAdditionalMail"] === undefined
        ? "0"
        : String(state.input["amsCustomerDetail.authenticateAlertAdditionalMail"]);
    let alertAuthFlg = IConstants.LOGIN_NOTIFY.INACTIVE;
    if (authenticateAlertMainMail === IConstants.FLAG.ACTIVE && authenticateAlertAdditionalMail === IConstants.FLAG.ACTIVE)
        alertAuthFlg = IConstants.LOGIN_NOTIFY.ACTIVE;
    else if (authenticateAlertMainMail === IConstants.FLAG.ACTIVE && authenticateAlertAdditionalMail === IConstants.FLAG.INACTIVE)
        alertAuthFlg = IConstants.LOGIN_NOTIFY.MAIN_MAIL;
    else if (authenticateAlertAdditionalMail === IConstants.FLAG.ACTIVE && authenticateAlertMainMail === IConstants.FLAG.INACTIVE)
        alertAuthFlg = IConstants.LOGIN_NOTIFY.ADDITIONAL_MAIL;
    state.input["amsCustomerDetail.alertAuthFlg"] = alertAuthFlg;
};

const validateSelfAssetAndBoMaxLoss = (state) => {
    validateBoMaxLossAmount(state);
    invalidSelfAssets(state);
    updateCboHedgeAmount(state);
};

const validateBoMaxLossAmount = (state) => {
    const input = {...state.input};
    const {amsWhitelabelConfigInfo} = state;
    if (isNil(input) || isEmpty(amsWhitelabelConfigInfo)) {
        return;
    }
    let messageBoMaxLossAmount = '';
    let validBoMaxLoss = true;
    const value = input['amsCustomerDetail.boLossMaxAmount'];
    const boMaxLossAmount = !isEmpty(value) ? value.replace(/[^0-9]/g, '') : '';
    if (boMaxLossAmount !== "") {
        const selfAssets = input['amsCustomerDetail.investmentAmount'];
        const amsMaxLossAmountValue = find(amsWhitelabelConfigInfo, item => (item.asserts == selfAssets)).value;
        const numberBoMaxLossAmount = Number(boMaxLossAmount.replace(/,/, ""));
        if (boMaxLossAmount && numberBoMaxLossAmount > Number(amsMaxLossAmountValue) || (boMaxLossAmount && numberBoMaxLossAmount <= 0)) {
            messageBoMaxLossAmount = i18n.t(ServiceUtils.getMessageMaxAmountError(amsMaxLossAmountValue));
            validBoMaxLoss = false;
        }
    }
    else {
        validBoMaxLoss = true;
    }
    state.input.validBoMaxLoss = validBoMaxLoss;
    state.input.messageBoMaxLossAmount = messageBoMaxLossAmount;

};

const invalidSelfAssets = (state) => {
    const input = {...state.input};
    const {amsWhitelabelConfigInfo} = state;
    if (isNil(input) || isEmpty(amsWhitelabelConfigInfo)) {
        return;
    }
    let errorMessageSelfAssets = '';
    let isInvalidSelfAssets = false;
    const boMaxloss = input['amsCustomerDetail.boLossMaxAmount'] || '';
    const boMaxLossAmount = boMaxloss.replace(/[^0-9.]/g, '');
    const selfAssets = input['amsCustomerDetail.investmentAmount'];
    const amsMaxLossAmountValue = find(amsWhitelabelConfigInfo, item => (item.asserts == selfAssets)).value;
    if (isNumber(boMaxLossAmount)) {
        if (boMaxLossAmount > amsMaxLossAmountValue) {
            errorMessageSelfAssets = i18n.t(ServiceUtils.getMessageMaxAmountError(amsMaxLossAmountValue));
            isInvalidSelfAssets = true;
        }
    }
    if (input['amsCustomerDetail.boInvestmentPurposeView'].boPurposeHedgeFlg === "1") {
        if (input["amsCustomerDetail.boPurposeHedgeAmount"] > input["amsCustomerDetail.investmentAmount"]) {
            if (state.isCorporation) {
                errorMessageSelfAssets = i18n.t('profile.error.sefl_assets.hedge_amount_conflick_corp');
            } else {
                errorMessageSelfAssets = i18n.t('profile.error.sefl_assets.hedge_amount_conflick_indv');
            }
            isInvalidSelfAssets = true;
        }
    }
    state.input.errorMessageSelfAssets = errorMessageSelfAssets;
    state.input.isInvalidSelfAssets = isInvalidSelfAssets;

};

const updateCboHedgeAmount = (state) => {
    const input = {...state.input};
    const {amsWhitelabelConfigInfo} = state;
    if (isNil(input) || isEmpty(amsWhitelabelConfigInfo)) {
        return;
    }
    const selfAssets = input['amsCustomerDetail.investmentAmount'];
    const listFinalAssetsWithHeader = [];
    for (let finalAssets in listFinalAssets) {
        if (listFinalAssets[finalAssets].key <= selfAssets) {
            listFinalAssetsWithHeader.push(listFinalAssets[finalAssets]);
        }
    }
    listFinalAssetsWithHeader.unshift({
        "key": "", value: 'profile.label.please_select'
    });
    state.input.listFinalAssetsWithHeader = listFinalAssetsWithHeader;
};

export default moduleProfile;
